var SaveThings = (function() {
    this.api_url = 'https://savevehicles.dealerinspire.com';
    this.site_id = -1;
    this.logged_in = false;
    this.login_path = '/login';
    this.social = 'y';

    function _init () {
        this.site_id = window.savethings.site_id;
        this.api_url = window.savethings.url || this.api_url;
        this.login_path = window.savethings.login_path || this.login_path;
        this.social = window.savethings.social || this.social;
        _checkAuth(); // Single fire to see if we're currently logged in.
    }

    // Pop the auth
    function _auth (successCallback) {
        var authWindow = window.open(this.api_url + this.login_path + '?s=' + this.social, '_new', "width=680,height=310,toolbar=0,scrollbars=1,status=0,resizable=0,location=0,menuBar=0,left=30,top=50");
        var interval = setInterval(function() {
            try {
                if (authWindow && authWindow.document.domain === document.domain) {
                    if (leftDomain && authWindow.document.readyState === "complete") {
                        // we're here when the authWindow window returned to our domain
                        clearInterval(interval);
                        authWindow.postMessage({
                            message: "requestResult"
                        }, "*");
                    }
                } else {
                    leftDomain = true;
                }
            } catch (e) {
                // we're here when the authWindow window has been navigated away or closed
                if (authWindow.closed) {
                    clearInterval(interval);
                    _checkAuth(successCallback);
                    return;
                }
                // navigated to another domain
                leftDomain = true;
            }
        }, 1000);
    }

    /*
        Copied ReadCookie and CreateCookie from inventory.js.
        SaveThings.js loads before inventory.js so the cookie functions don't exist yet.
        Ideally we should test loading inventory.js as a dependency as savethings.js.
    */
    function ReadCookie(c_name) {
        var c_value = document.cookie;
        var c_start = c_value.indexOf(" " + c_name + "=");

        if (c_start == -1) {
            c_start = c_value.indexOf(c_name + "=");
        }
        if (c_start == -1) {
            c_value = null;
        } else {
            c_start = c_value.indexOf("=", c_start) + 1;
            var c_end = c_value.indexOf(";", c_start);
            if (c_end == -1) {
                c_end = c_value.length;
            }
            c_value = unescape(c_value.substring(c_start, c_end));
        }
        return c_value ? c_value : null;
    }

    /* Copied CreateCookie from inventory.js */
    function CreateCookie(name, value, days) {
        var expires = '';
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toGMTString();
        } else
            expires = "";
            if (typeof value == 'object') {
            value = JSON.stringify(value);
        }
        document.cookie = escape(name) + "=" + escape(value) + expires + "; path=/";
    }

    function _authWithEmail(email, successCallback) {
        var self = this;

        jQuery.ajax({
            url: this.api_url + '/login/email/force?email='+email+'&iframe=true',
            dataType: 'jsonp',
            cache: false
        }).always(function(data) {
            if ( typeof data.id !== 'undefined' && data.id && data.id.length > 0 ) {
                CreateCookie('savethings_hash', data.id, 30);
                if (successCallback) {
                    _checkAuth(successCallback);
                }
            }
        });
    }

    function triggerEvent(eventName) {
        try {
            var event = new CustomEvent(eventName)
        }
        catch (error) {
            var event = document.createEvent('CustomEvent')
            event.initCustomEvent(eventName, true, true)
        }
        document.dispatchEvent(event);
    }

    function _checkAuth (successCallback, failureCallback) {
        var self = this;

        post_data = jQuery.extend({}, defaultAjaxData());

        jQuery.ajax({
            url: this.api_url + '/login/check',
            dataType: 'jsonp',
            cache: false,
            data: post_data
        }).always(function(data) {
            if (data && data.id) {
                self.logged_in = true;
                _showLogout();
                if (typeof successCallback != 'undefined') {
                    successCallback();
                    jQuery('body').trigger('savethings-logged-in');
                }
            } else {
                self.logged_in = false;
                _showLogin();
                if ( typeof failureCallback != 'undefined') {
                    failureCallback();
                    jQuery('body').trigger('savethings-auth-failed');
                }
            }
            jQuery('body').trigger('savethings-auth-completed');
        });
    }

    function defaultAjaxData() {
        var object = {};
        var hash = ReadCookie('savethings_hash');

        if ( typeof hash !== 'undefined' && hash && hash.length > 0 ) {
            object.hash = hash;
        }

        return object;
    }

    function _fetchItems () {
        post_data = jQuery.extend(defaultAjaxData(), {
            site_id: this.site_id
        });

        return jQuery.ajax({
            url: this.api_url + '/items',
            data: post_data,
            dataType: 'jsonp'
        }).always(function () {
            jQuery('body').trigger('savethings-list-complete');
        });
    }

    function _logout () {
        jQuery.ajax({
            url: this.api_url + '/signout',
            dataType: 'jsonp',
            cache: false
        }).always(function(data) {
            _showLogin();
        });
    }

    function _removeItem (remote_id, success, failure) {
        post_data = jQuery.extend(defaultAjaxData(), {
            site_id: this.site_id,
            remote_id: remote_id
        });

        jQuery.ajax({
            url: this.api_url + '/items/remove',
            data: post_data,
            dataType: 'jsonp',
            success: function (data) {
                if (typeof success != 'undefined') {
                    triggerEvent('remove-saved-vehicle')
                    success();
                }
            },
            error: function () {
                if (typeof failure != 'undefined') {
                    failure();
                }
            }
        });
    }

    function _saveItem (item, success, failure) {
        post_data = jQuery.extend(defaultAjaxData(), {
            site_id: this.site_id
        }, item);

        if (!this.logged_in) {
            _auth(function () {
                _saveItem(item, success, failure);
            });
        } else {
            jQuery.ajax({
                url: this.api_url + '/items/add',
                data: post_data,
                dataType: 'jsonp',
                success: function (data) {
                    if (typeof success != 'undefined') {
                        triggerEvent('add-saved-vehicle')
                        success();
                    }
                },
                error: function () {
                    if (typeof failure != 'undefined') {
                        failure();
                    }
                }
            });
        }
    }

    function _showLogin () {
        jQuery('.savethings-logout').remove();

        jQuery(function () {
            if (jQuery('.savethings-login').length == 0) {
                var loginLink = jQuery('<button class="button primary-button block">' + savethings.translate.login + '</button>').text(savethings.translate.login_to_save).addClass('savethings-login').css({
                    width: '100%'
                });
                jQuery('.initial-saved-vehicles').prepend(loginLink);
            }

            jQuery('.button.savethings-login').on('click', function() {
                SaveThings.authPopup(loadSavedItems);
            });
        });
    }

    function _showLogout () {
        jQuery('.savethings-login').remove();
        jQuery(document).ready(function () {
            /*
            logoutLink = jQuery('<button></button>').text('Logout of SaveThings').addClass('savethings-logout').css({zIndex: 9999, position: 'absolute'});
            jQuery('body').prepend(logoutLink);

            logoutLink.on('click', SaveThings.logout);
            */
        });
    }

    if (typeof window.savethings !== 'undefined') {
        document.addEventListener('DOMContentLoaded', function() {
            _init();
        });

        return {
            authPopup: function (successCallback) {
                _auth(successCallback);
            },
            authWithEmail: function(email, successCallback) {
                _authWithEmail(email, successCallback);
            },
            checkAuth: function(successCallback, failureCallback) {
                _checkAuth(successCallback, failureCallback);
            },
            list: function () {
                return _fetchItems();
            },
            logout: function () {
                _logout();
            },
            save: function (item, success, failure) {
                _saveItem(item, success, failure);
            },
            remove: function (item_id, success, failure) {
                _removeItem(item_id, success, failure);
            }
        };
    }
})();

var existingItems = [];
var existingItemIDs = [];

var loadSavedItems = function () {
    var existingItemsPromise = SaveThings.list();
    existingItemsPromise.success(insertSavedItems);
};

var insertSavedItems = function (data) {
    if (data.items.length > 0) {
        jQuery('.save-vehicles .initial-saved-vehicles').remove();
    }
    jQuery.each(data.items, function (i, v) {
        existingItemIDs.push(v.remote_id);
        jQuery(".save-vehicles").append('<div class="vehicle saved-' + v.remote_id + ' "><h5><img src="/wp-content/plugins/inventory/js/fancybox/fancy_close.png" alt="close" class="remove-saved-vehicle" data-remote-id="' + v.remote_id + '" style="vertical-align:middle"> <a href="' + v.url + '">' + v.title + '</a></h5><a href="' + v.url + '">' + '<span class="sr-hidden">' + v.title + '</span>' + '<img class="thumbnail" src="' + v.thumbnail_url + '" alt="'+ v.title +'" /></a></div>');
        jQuery('body').trigger('savethings-drawer-loaded');
    });
};

jQuery(function () {
    if (typeof window.savethings == 'undefined' ) {
        return;
    }
    var self = this,
        sidrToggle = jQuery("#save-vehicles-expand-btn, #save-vehicles-custom-toggle");

    jQuery("#save-vehicles-expand-btn, #save-vehicles-custom-toggle").sidr({
        name: 'save-vehicles-sidr',
        side: savethings.position,
        onOpen: function () {
            if (savethings.position == 'left') {
                jQuery(sidrToggle).animate({
                    marginLeft: 260
                }, 200);
            } else {
                jQuery(sidrToggle).animate({
                    marginRight: 260
                }, 200);
            }
        },
        onClose: function () {
            if (savethings.position == 'left') {
                jQuery(sidrToggle).animate({
                    marginLeft: 0
                }, 200);
            } else {
                jQuery(sidrToggle).animate({
                    marginRight: 0
                }, 200);
            }
        }
    });

    // Remove the item by clicking on the close button on the sidr item
    jQuery(document).on('click', '.remove-saved-vehicle', function (e) {
        if (typeof window.savethings == 'undefined' ) {
            return;
        }

        var self = this,
            vin = jQuery(this).data('remoteId');

        SaveThings.remove(jQuery(this).data('remoteId'), function () {
            jQuery(self).html(savethings.translate.save_this_vehicle).removeClass('saved-thing');
            jQuery(".save-vehicles div.saved-" + vin).fadeOut(140, function () {
                jQuery(this).remove();
            });
        });
    });

    jQuery(document).on('click', function(e) {
      var clicked = e.target;
      if(typeof jQuery.sidr != 'undefined' && jQuery(clicked).parents(".sidr").length < 1 && !(jQuery(clicked).hasClass("sidr")) )
        jQuery.sidr('close', 'save-vehicles-sidr');
    });

    // Save something by clicking on the save button
    jQuery(document).on('click', '.save-things-save', function (e) {
        if (typeof window.savethings == 'undefined' ) {
            return;
        }
        e.preventDefault();

        var self = this,
            title = jQuery(this).data('title'),
            thumbnailUrl = jQuery(this).data('thumbnailUrl'),
            amount = jQuery(this).data('amount'),
            url = jQuery(this).data('url'),
            vin = jQuery(this).data('remoteId'),
            cart = jQuery('.save-vehicles'),
            alreadySaved = jQuery(cart).find('.saved-' + vin),
            isVRP = jQuery('#results-page').length ? true : false;
            VDPid = ( jQuery('.project-hotwheels').length > 0 ) ? jQuery('#vehicleDetails') : jQuery('#detailspage');

        // Save the vehicle
        SaveThings.save({
            title: title,
            thumbnail_url: thumbnailUrl,
            amount: amount,
            url: url,
            remote_id: vin
        }, function () {
            var imgtodrag = isVRP ? jQuery(self).parents(".vehicle").find(".vehicle-image img") : jQuery(VDPid).find("#gallery-carousel img, #condensed-gallery-carousel img").first(),
                vehicle_image = jQuery(imgtodrag).attr("src"),
                vehicle_title = jQuery(self).data('title') ? jQuery(self).data('title') : jQuery(self).closest(".vehicle").find(".vehicle-overview").attr("title");

            if (alreadySaved.length !== 0) {
                return;
            }

            if (typeof imgtodrag !== 'undefined' && imgtodrag.length > 0) {
                var imgclone = imgtodrag.clone().offset({
                        top: imgtodrag
                            .offset().top,
                        left: imgtodrag
                            .offset().left
                    })
                    .css({
                        'opacity': '0.5',
                        'position': 'absolute',
                        'height': '150px',
                        'width': '150px',
                        'z-index': '100'
                    })
                    .appendTo(jQuery('body'));

                if (savethings.position == 'left') {
                    imgclone.animate({
                            'top': cart.offset().top + 100,
                            'left': cart.offset().left + 10,
                            'width': 150,
                            'height': 150,
                            'zIndex': 10000,
                        },
                        1000,
                        'easeOutQuart',
                        function () {
                            jQuery('.initial-saved-vehicles', cart).remove();
                            jQuery(cart).append('<div class="vehicle saved-' + vin + '"><h5><img src="/wp-content/plugins/inventory/js/fancybox/fancy_close.png" class="remove-saved-vehicle" data-remote-id="' + vin + '" style="vertical-align:middle"> <a href="' + url + '">' + vehicle_title + '</a></h5><a href="' + url + '"><img class="thumbnail" src="' + vehicle_image + '" /></a></div>');
                        });
                } else {
                    imgclone.animate({
                            'top': cart.offset().top + 100,
                            'left': jQuery(window).width() - 10,
                            'width': 150,
                            'height': 150,
                            'zIndex': 10000,
                        },
                        1000,
                        'easeOutQuart',
                        function () {
                            jQuery('.initial-saved-vehicles', cart).remove();
                            jQuery(cart).append('<div class="vehicle saved-' + vin + '"><h5><img src="/wp-content/plugins/inventory/js/fancybox/fancy_close.png" class="remove-saved-vehicle" data-remote-id="' + vin + '" style="vertical-align:middle"> <a href="' + url + '">' + vehicle_title + '</a></h5><a href="' + url + '"><img class="thumbnail" src="' + vehicle_image + '" /></a></div>');
                        });
                }

                imgclone.animate({
                    'width': 0,
                    'height': 0
                }, function () {
                    jQuery(this).detach();
                });

                jQuery(self).addClass('save-things-saved');
                jQuery('#save-vehicles-expand-btn, #save-vehicles-custom-toggle, .mobile-tab.saved').addClass("vehicles-saved");

                jQuery('body').trigger('savethings-save-vehicle', self);
            }

        }, function () {
            //alert('Bummer, something went wrong.');
        });
    });

    // Initialize the sidr drawer and saved vehicles button for saved vehicles
    jQuery("body").on("vrp-ajax-complete", function () {
        var savedButton = jQuery("#save-vehicles-expand-btn");

        setTimeout(function () {
            jQuery(savedButton).show();
            jQuery(savedButton).sidr({
                name: 'save-vehicles',
                side: 'left',
                onOpen: function () {
                    jQuery(savedButton).animate({
                        marginLeft: 260
                    }, 200);
                },
                onClose: function () {
                    jQuery(savedButton).animate({
                        marginLeft: 0
                    }, 200);
                }
            });
        }, 500);
    });

    loadSavedItems();
    markSavedItems();

});

function markSavedItems() {
  // listen for a bunch of events
  var loadEvents = ( jQuery('#results-page').length ) ? 'savethings-list-complete savethings-drawer-loaded vrp-ready vrp-ajax-complete' : 'savethings-list-complete savethings-drawer-loaded';
  var isVRP = jQuery('#results-page').length;
  var isHotwheels = jQuery('.project-hotwheels').length;

  jQuery('body').on(loadEvents, function() {
    var saveVehiclesSidr = jQuery('#save-vehicles-sidr'),
      vinElements = jQuery('[data-remote-id]', saveVehiclesSidr),
      savedVins = [];

    // add the vins from the saved things drawer into an array
    if (saveVehiclesSidr.length) {
      jQuery(vinElements).each(function(index, value) {
        savedVins.push(jQuery(this).data('remote-id'));
      });
    }

    // loop through each vehicle on the VRP
    if(isVRP) {
      jQuery('.vehicle').each(function(index, value) {
        var saveBtn = jQuery(this).find('.save-things-save'),
          vin = jQuery(saveBtn).attr('rel');

        // check this vehicle's vin against our array of saved vins
        if (jQuery.inArray(vin, savedVins) > -1) {
          jQuery(saveBtn).addClass('save-things-saved');
          jQuery(saveBtn).find('.button-text').text("Saved");
        }
      });
    }
    else {
      jQuery('.save-vehicle').each(function(index, value) {
        var vin = jQuery(this).data('remote-id');

        if($.inArray(vin, savedVins) > -1) {
          jQuery(this).addClass("save-things-saved").find(".button-text").text("Saved");
        }
      });
    }
    if(savedVins.length > 0) {
      jQuery('#save-vehicles-expand-btn, #save-vehicles-custom-toggle, .mobile-tab.saved').addClass("vehicles-saved");
    }
  });
}
